module.exports = __webpack_public_path__ + "glyphicons-halflings-regular.fa2772327f55d8198301.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/glyphicons-halflings-regular.woff
// module id = 959
// module chunks = 7